import React, { useCallback, useEffect, useState } from 'react'
import Grid from '@mui/material/Grid2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { apiService } from '../../../../../services/apiService';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { Box } from '@mui/material';
import { Modal } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
function TaskAllHistoryCase() {
    const location = useLocation();
    const parts_location = location.pathname.split("/");
    const caseIds = parts_location[4] || null;
    const [showhistory, setvalidateHistory] = useState([]);
    const [loading, setLoading] = useState(true);
    const [paginatedata, setPaginateData] = useState({});
    const [currentPage, setCurrentPage] = useState(1);

    const fetchData = useCallback(async (params = {}) => {
        setLoading(true);
        try {
            const defaultParams = { ...params };
            const queryString = new URLSearchParams(defaultParams).toString();
            const response = await apiService.getRequest(`/case/${caseIds}/history?${queryString}`);
            if (response && response.success === true) {
                setvalidateHistory(response.data);
                setPaginateData(response.meta);
            }else{
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (error) {
            console.error('Error fetching tab data:', error);
        } finally {
            setLoading(false);
        }
    }, [caseIds]);
    
    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
        fetchData({ page: newPage });
    };
    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const [show, setShow] = useState(false);
    const [modalData, setModalData] = useState(null);
    
    const handleClose = () => setShow(false);
    
    const handleShow = (data) => {
        setModalData(data);
        setShow(true);
    };
    const sanitizeAndDisplayHTML = (html) => {
        const sanitizedHTML = html
        return sanitizedHTML;
    };
  return (
    <div className='container-fluid px-0'>
        {loading ? 
        <div className='d-flex justify-content-center w-100 mt-5 pt-5'>
            <img style={{ width: "100px" }} src={require('../../../../../assets/pinkloader.gif')} alt='Loading...' />
        </div> :<>
        {showhistory && showhistory.length > 0 ? ( showhistory && showhistory.map((history, index) => (
            <Box key={index} sx={{ mb: 4, overflow: "auto" }}>
                <Grid size={{xs:12}} container justifyContent="space-between" className="span_timeshowers mt-3">
                    <span>{history.datetime}</span>
                    <span><b>Updated by</b> {history.updated_by}</span>
                </Grid>

            {/* Data Grid */}
            <Box sx={{ width: "100%", mt: 2 }} className="dtagridhistory_pagi">
                <DataGrid
                style={{minHeight:"200px"}}
                rows={history && history.history.map((field, fieldIndex) => ({
                    id: fieldIndex,
                    taskId: field.task_formatted_id,
                    action: field.action || "N/A",
                    value: field.value || "N/A",
                }))}
                columns={[
                    {
                        field: 'taskId',
                        headerName: 'Task Id',
                        width: 200,
                        renderCell: (params) => (
                            <div className='d-flex align-items-center h-100'>
                                <span style={{color:"#1a5298"}} className='firstlett_caps'>
                                    {params.row.taskId}
                                </span>
                            </div>
                        ),
                        filterable: false,
                        sortable: false,
                    },
                    {
                        field: 'action',
                        headerName: 'Action',
                        width: 500,
                        renderCell: (params) => (
                            <div className='d-flex align-items-center h-100'>
                                <span className='firstlett_caps'>
                                    {params.row.action}
                                </span>
                            </div>
                        ),
                        filterable: false,
                        sortable: false,
                    },
                    {
                        field: 'value',
                        headerName: 'Value',
                        width: 500,
                        renderCell: (params) => (
                            <div className='d-flex align-items-center h-100'>
                                <span className='firstlett_caps'>
                                    {params.row.action === "Rollback" ? (
                                        <button 
                                            className="hisconten_view_btn" 
                                            onClick={() => handleShow(params.row.value || 'N/A')}
                                        >
                                            View
                                        </button>
                                        ) : (
                                        params.row.value && params.row.value.length > 50 ? (
                                            <button 
                                            className="hisconten_view_btn" 
                                            onClick={() => handleShow(params.row.value)}
                                            >
                                            View
                                            </button>
                                        ) : (
                                            params.row.value || 'N/A'
                                        )
                                        )}
                                </span>
                            </div>
                        ),
                        filterable: false,
                        sortable: false,
                    },
                ]}
                disableSelectionOnClick
                components={{ Toolbar: GridToolbar }}
                />
            </Box>
            </Box>
        ))) : (
            <div className="w-100 d-flex justify-content-center mt-4">
                <p>No data to display</p>
            </div>
        )}</>}
        <Grid size={{xs:12}} container justifyContent="center" className="mt-4 pagination_btn">
            <button className='arrowpaginate'
                onClick={() => handlePageChange(currentPage - 1)} 
                disabled={currentPage === 1}>
                <FontAwesomeIcon icon={faChevronLeft} />
            </button>
            {paginatedata && (
                <div className="pagination">
                    {(() => {
                    const totalPages = paginatedata.last_page > 0 ? paginatedata.last_page : 1;
                    const pages = [];
                    const start = Math.max(2, currentPage - 2);
                    const end = Math.min(totalPages - 1, currentPage + 2);

                    // Always show first page
                    pages.push(
                        <button
                        key={1}
                        onClick={() => handlePageChange(1)}
                        className={currentPage === 1 ? 'active' : ''}
                        >
                        1
                        </button>
                    );

                    if (start > 2) {
                        pages.push(<span key="start-ellipsis">...</span>);
                    }

                    for (let i = start; i <= end; i++) {
                        pages.push(
                        <button
                            key={i}
                            onClick={() => handlePageChange(i)}
                            className={currentPage === i ? 'active' : ''}
                        >
                            {i}
                        </button>
                        );
                    }

                    if (end < totalPages - 1) {
                        pages.push(<span key="end-ellipsis">...</span>);
                    }

                    if (totalPages > 1) {
                        pages.push(
                        <button
                            key={totalPages}
                            onClick={() => handlePageChange(totalPages)}
                            className={currentPage === totalPages ? 'active' : ''}
                        >
                            {totalPages}
                        </button>
                        );
                    }

                    return pages;
                    })()}
                </div>
                )}

            <button className='arrowpaginate'
                onClick={() => handlePageChange(currentPage + 1)} 
                disabled={currentPage === paginatedata.last_page}>
                <FontAwesomeIcon icon={faChevronRight} />
            </button>
        </Grid>
        <Modal size='lg' centered show={show} onHide={handleClose}>
            <Modal.Header closeButton>
            </Modal.Header>
            <Modal.Body className='mb-3'>
                <div className='w-100' dangerouslySetInnerHTML={{ __html: sanitizeAndDisplayHTML(modalData) }} />
            </Modal.Body>
        </Modal>
    </div>
)}

export default TaskAllHistoryCase
